import { render, staticRenderFns } from "./payment_provisioning.vue?vue&type=template&id=5048b9cb&scoped=true&"
import script from "./payment_provisioning.vue?vue&type=script&lang=js&"
export * from "./payment_provisioning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5048b9cb",
  null
  
)

export default component.exports